import "./dashboard-profile.scss";
import Card from "src/components/Card";
import CompanySignerForm from "src/components/forms/profile/CompanySigner";
import EditAddress from "src/components/forms/profile/EditAddress";
import EditBankAccount from "src/components/forms/profile/EditBankAccount";
import EditUser from "src/components/forms/profile/EditUser";
import ResetPassword from "src/components/forms/profile/ResetPassword";
import Grid from "src/components/Grid";
import KeyValue from "src/components/KeyValue";
import Layout from "src/components/layout/Layout";
import useAuth from "src/hooks/selectors/useAuth";
import ProfileTabs from "src/views/authenticated/profile/ProfileTabs";
import FormGrid from "src/components/form/FormGrid";
import LanguageSelectList from "src/components/language/LanguageSelectList";
import { useTranslation } from "react-i18next";
import EditInterests from "src/components/forms/profile/EditInterests";
import Button from "src/components/Button";

export default function ProfileView() {
	const { t } = useTranslation("profile-view", {
		keyPrefix: "my-profile-view",
	});
	const auth = useAuth();

	if (auth.type === "company") {
		return (
			<Layout className="dashboard-profile" title={t("title")}>
				<ProfileTabs />
				<FormGrid>
					<FormGrid.Header
						title={t("cards.account")}
					></FormGrid.Header>
					<FormGrid.Card>
						<EditUser />
					</FormGrid.Card>
					<FormGrid.Header
						title={t("cards.signer")}
					></FormGrid.Header>
					<FormGrid.Card>
						<CompanySignerForm />
					</FormGrid.Card>
					<FormGrid.Header
						title={t("cards.password")}
					></FormGrid.Header>
					<FormGrid.Card>
						<ResetPassword />
					</FormGrid.Card>
					<FormGrid.Header title={t("cards.language")} />
					<FormGrid.Card>
						<LanguageSelectList
							button={{
								label: t("save"),
							}}
						/>
					</FormGrid.Card>
				</FormGrid>
			</Layout>
		);
	}

	return (
		<Layout className="dashboard-profile" title={t("title")}>
			<ProfileTabs />
			<Grid columns={1}>
				<Grid columns={auth.type === "student" ? 2 : 1}>
					<Card title={t("cards.account")}>
						<EditUser />
					</Card>
					<Grid>
						<Card title={t("cards.password")}>
							<ResetPassword />
						</Card>
						<EditBankAccount />
						<Card title={t("cards.address")}>
							<div className="flex flex-col gap-1 mb-4">
								{auth?.address && (
									<div className="flex flex-col gap-2">
										<KeyValue.Small
											label={t("address.street")}
											text={auth?.address?.street}
										/>
										<KeyValue.Small
											label={t("address.house-number")}
											text={auth?.address?.house_number}
										/>
										<KeyValue.Small
											label={t("address.zipcode")}
											text={auth?.address?.zipcode}
										/>
										<KeyValue.Small
											label={t("address.city")}
											text={auth?.address?.city}
										/>
									</div>
								)}
							</div>
							<EditAddress />
						</Card>
					</Grid>
				</Grid>
				<Card title={t("cards.interests")}>
					<EditInterests
						renderButtons={({
							onSubmit,
							isSubmitting,
							isValid,
						}: any) => (
							<div>
								<Button
									type="primary"
									disabled={!isValid}
									loading={isSubmitting}
									onClick={onSubmit}
								>
									{t("save")}
								</Button>
							</div>
						)}
					/>
				</Card>
			</Grid>
		</Layout>
	);
}
